import apiClient from "@/services/api.ts";
import {
  OperationTemplate,
  Parameter,
  ParameterValue,
  Template,
} from '@/components/shared/report-template/types/editor.ts';

export default {
  async saveTemplate(data: Template) {
    return await apiClient.post(`template/create`, data);
  },
  async updateTemplate(templateId: string, data: Partial<Template>) {
    return await apiClient.put(`template/${templateId}/update`, data);
  },
  async getTemplate() {
    return await apiClient.get(`template/list`);
  },
  async getTemplateByType(type: string) {
    return await apiClient.get(`template/type/${type}`);
  },
  async getTemplateDetail(templateId: number) {
    return await apiClient.get(`template/${templateId}`);
  },
  async updateStatusTemplate(templateId: number, status: string) {
    return await apiClient.put(`template/${templateId}/status/${status}`);
  },
  async deleteTemplate(templateId: number) {
    return await apiClient.delete(`template/${templateId}`);
  },
  async saveParameterTemplate(data: Parameter) {
    return await apiClient.post(`template/parameter/create`, data);
  },
  async getParameterTemplate() {
    return await apiClient.get(`template/parameter`);
  },
  async saveParameterValue(data: ParameterValue) {
    return await apiClient.post(`template/parameter/value/create`, data);
  },
  async updateTemplateBatch(templateId: number, data: Partial<OperationTemplate>) {
    return await apiClient.put(`template/${templateId}/update`, data);
  }
}
